import { SPACING_M, SPACING_L } from "../../helpers";
export var config = {
    paddingLeft: SPACING_L,
    paddingRight: SPACING_M
};
//# sourceMappingURL=helpers.js.map